<template>
  <div class="home">
    <div class="filter-wrapper filter-wrapper-tab">
      <div class="link-filter-wrapper">
        <div>
          <v-select
            v-model="dataSelectLastDayValue"
            :options="dataSelectOptionsLastDay"
            :filterable="false"
            :searchable="false"
            :clearable="false"
            :components="{ Deselect: dataComponentDeselect }"
            striped
            :class="[
              'call-select',
              dataSelectLastDayValue ? 'call-select--value' : null
            ]"
            @input="$_ajax({ reset: true })">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                {{ option.label }}
              </div>
            </template>
          </v-select>

          <v-select
            v-if="dataTimezoneValue !== null"
            v-model="dataTimezoneValue"
            label="name"
            :components="{ Deselect: dataComponentDeselect }"
            :class="[
              'call-select',
              dataTimezoneValue ? 'call-select--value' : null
            ]"
            :options="dataSelectOptionsTimezone"
            :filterable="false"
            :searchable="false"
            :clearable="false"
            striped
            @input="$_ajax({ reset: true })">
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                {{ option.name }}
              </div>
            </template>
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
          </v-select>

          <v-select
            v-model="dataSelectBonusValue"
            :options="dataSelectOptionsBonus"
            label="description"
            :components="{ Deselect: dataComponentDeselect }"
            placeholder="All Bonuses"
            :class="[
              'call-select call-select-filter teams-filter',
              dataSelectBonusValue ? 'call-select--value' : null,
            ]"
            @input="$_ajax({ reset: true })">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
            <template slot="no-options">
              Name Team
            </template>
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                <!-- <font-awesome-icon
                  v-if="!option.is_active"
                  class="tabel-icon--red"
                  style="font-size: 10px"
                  :icon="dataIconLock" /> -->
                {{ option.description }}
              </div>
            </template>
          </v-select>
        </div>
        <div />
      </div>
    </div>

    <div class="table__title filter-wrapper gifts-report-project__title">
      <h2>{{ computedGiftsCount }} Gifts Sent</h2>
      <call-pagination
        page-calc
        :page-value="50"
        :obj-pagination="dataObjPagination"
        @on-pagination="$_ajax" />
    </div>

    <div class="table-wrapper">
      <b-table
        :show-empty="isLoaded"
        striped
        hover
        no-local-sorting
        :fields="dataMixinGiftsReportProjectFields"
        :items="dataPlayersList"
        sort-by="task_id"
        :sort-desc="dataDesc"
        @sort-changed="onSortTabel">
        <template #empty>
          <EmptyTable />
        </template>
        <template #cell(actions)="data">
          <div class="table_actions">
            <call-tooltip
              placement="top"
              content="Info">
              <call-button
                outlet
                type="success"
                round
                not-border
                :icon="dataIconEye"
                @click="onActions(data.item, 'view')" />
            </call-tooltip>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import CallPagination from '@/components/desktop/CallPagination';
import CallButton from '@/components/common/CallButton';
import { BTable } from 'bootstrap-vue';
import {
  BONUS_PLAYERS,
  GET_BONUS_LIST_PROJECT,
  PROJECTS_GET,
  TEAMS_GET
} from '../../../store/types/actions.types';
import {
  faChevronDown,
  faEye
} from '@fortawesome/pro-regular-svg-icons';
import helper from '../../../service/helper';
import giftsReportProjectTable from '../../../mixins/table/giftsReportProjectTable';
import selectProjectPeriod from '../../../mixins/select/selectProjectPeriod';

// order_by: id | created_at
const dataOrderMap = {
  task_id: 'id',
  id: 'id',
  created_at: 'created_at'
};

export default {
  name: 'CallsGiftsReportProject',
  components: {
    CallPagination,
    CallButton,
    BTable
  },
  mixins: [
    selectProjectPeriod,
    giftsReportProjectTable
  ],
  data () {
    return {
      dataIconEye: faEye,
      dataIconDown: faChevronDown,
      isLoaded: false,
      dataProjectId: null,
      dataTeamId: null,
      dataPlayersList: [],
      dataObjPagination: {},
      dataDesc: true,
      dataOrderBy: 'id',
      dataTimezoneValue: null,
      dataSelectOptionsTimezone: [],
      dataSelectOptionsBonus: [],
      dataSelectBonusValue: null,
      dataSelectLastDayValueDefault: {
        key: 'day',
        label: 'Today'
      },
      dataSelectLastDayValue: {
        key: 'day',
        label: 'Today'
      },
      dataSelectOptionsLastDay: [
        {
          key: 'day',
          label: 'Today'
        },
        {
          key: 'last_day',
          label: 'Yesterday'
        },
        {
          key: 'week',
          label: 'This Week'
        },
        {
          key: 'last_week',
          label: 'Last Week'
        },
        {
          key: 'month',
          label: 'This Month'
        },
        {
          key: 'last_month',
          label: 'Last Month'
        }
      ]
    };
  },

  computed: {
    computedGiftsCount () {
      const { count = 0 } = this.dataObjPagination;
      return count || 0;
    }
  },

  async created () {
    this.dataProjectId = this.$route.params.projectId;

    this.$_ajax = ((options = {}) => {
      this.isLoaded = false;

      let _page = 0;
      let _limit = 50;

      const { currentRoute: { name: pageName } = {} } = this.$router;
      const _filterKey = `_filter${pageName}`;

      if (!helper.isEmpty(this.$route.query, _filterKey)) {
        try {
          options = helper.clearObject(
            JSON.parse(this.$route.query[_filterKey])
          );

          const _arrFilter = [
            'desc',
            'orderBy',
            'limit',
            'page',
            'period',
            'timezone',
            'bonus_ids'
          ];

          for (const _key of _arrFilter) {
            if (!helper.isEmpty(options, _key)) {
              switch (_key) {
                case 'desc':
                  this.dataDesc = options[_key];
                  break;
                case 'orderBy':
                  this.dataOrderBy = options[_key];
                  break;
                case 'limit':
                  _limit = options[_key];
                  break;
                case 'page':
                  _page = options[_key];
                  break;
                case 'period':
                  this.dataSelectLastDayValue = options[_key];
                  break;
                case 'timezone':
                  this.dataTimezoneValue = options[_key];
                  break;
                case 'bonus_ids':
                  this.dataSelectBonusValue = options[_key];
                  break;
              }
            }
          }
        } catch (e) {
          console.log('Error query params');
        }
      }

      return async ({
        limit = null,
        page = null,
        reset = false
      } = options) => {
        this.$store.dispatch('loading/startLoading');

        try {
          if (!this.dataSelectLastDayValue) {
            this.dataSelectLastDayValue = {
              ...this.dataSelectLastDayValueDefault
            };
          }

          if (!helper.isEmpty(page) && page !== _page) {
            _page = page;
          }

          if (!helper.isEmpty(limit) && limit !== _limit) {
            _limit = limit;
          }

          if (reset) {
            _page = 0;
          }

          const {
            payload = [],
            misc: { paging = {} } = {}
          } = await this.$store.dispatch(`bonus/${BONUS_PLAYERS}`, {
            params: {
              project_id: this.dataProjectId,
              bonus_ids: [this.dataSelectBonusValue?.id],
              period: this.dataSelectLastDayValue?.key,
              timezone: this.dataTimezoneValue?.id,
              // order_by: this.dataOrderBy,
              // desc: this.dataDesc,
              limit: _limit,
              page: _page
            }
          });

          this.dataPlayersList = payload || [];
          this.dataObjPagination = helper.isEmpty(paging)
            ? {
                page: _page,
                limit: _limit,
                count: this.dataPlayersList.length
              }
            : paging;

          this.$router
            .replace({
              ...this.$router.currentRoute,
              query: {
                ...(this.$route.query || {}),
                [_filterKey]: JSON.stringify(
                  helper.clearObject({
                    period: this.dataSelectLastDayValue,
                    timezone: this.dataTimezoneValue,
                    bonus_ids: this.dataSelectBonusValue,
                    orderBy: this.dataOrderBy,
                    desc: this.dataDesc,
                    limit: _limit,
                    page: _page
                  })
                )
              }
            })
            .catch(() => {});

          options = {};
          this.isLoaded = true;
        } finally {
          this.$store.dispatch('loading/stopLoading');
        }
      };
    })();

    this.$store.dispatch('loading/startLoading');

    try {
      await this.getProject();

      await Promise.all([this.getBonuses(), this.$_ajax()]);
    } finally {
      this.$store.dispatch('loading/stopLoading');
    }
  },

  methods: {
    async getProject () {
      try {
        const { payload: { project = {} } = {} } = await this.$store.dispatch(
          `project/${PROJECTS_GET}`,
          {
            projectId: this.dataProjectId
          }
        );

        this.dataTeamId = project?.team_id;

        await this.getTeamTimezone(project);
      } catch (e) {
        console.log(e);
      }
    },

    async getTeamTimezone (project = {}) {
      try {
        if (this.dataTeamId === null || this.dataTeamId === undefined) {
          return;
        }

        const { team = {} } = await this.$store.dispatch(`team/${TEAMS_GET}`, {
          params: {
            id: this.dataTeamId
          }
        });

        const utcList = this.$store.state.team.utc;
        const teamZone = utcList.find(
          ({ id } = {}) => id === team?.timezone_offset
        ) || utcList.find(({ id } = {}) => id === 0);

        this.dataSelectOptionsTimezone =
          team?.timezone_offset === 0
            ? [teamZone]
            : [
                teamZone,
                utcList.find(({ id } = {}) => id === 0)
              ];

        if (helper.isEmpty(this.dataTimezoneValue)) {
          this.dataTimezoneValue = teamZone;
        }

        this.breadcrumbProjectName(team, project);
      } catch (e) {
        console.log(e);
      }
    },

    breadcrumbProjectName (team = {}, project = {}) {
      if (typeof this.$route.query?.projectName === 'string') {
        return;
      }

      const projectName = [team?.name, project?.name]
        .filter((item) => !!item)
        .join(' | ');

      if (!projectName) {
        return;
      }

      this.$router
        .replace({
          ...this.$router.currentRoute,
          query: {
            ...(this.$route.query || {}),
            projectName
          }
        })
        .catch(() => {});
    },

    async getBonuses () {
      try {
        this.dataSelectOptionsBonus = await this.$store.dispatch(
          `bonus/${GET_BONUS_LIST_PROJECT}`,
          {
            projectId: this.dataProjectId
          }
        );
      } catch (e) {
        console.log(e);
      }
    },

    onSortTabel ({ sortBy, sortDesc }) {
      this.dataOrderBy = dataOrderMap[sortBy] || 'id';
      this.dataDesc = sortDesc;
      this.$_ajax({ reset: true });
    },

    onActions ({ task_id: taskId, player_id: playerId }, action) {
      switch (action) {
        case 'view':
          this.$router.push({
            name: 'ProjectTasksDetail',
            params: {
              taskId,
              projectId: this.dataProjectId
            },
            query: {
              taskName: `ID: ${playerId}`
            }
          });
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.gifts-report-project__title {
  align-items: center;
  justify-content: space-between;

  .pagination__wrapper {
    margin-bottom: 0;
  }
}
</style>
